// Builds a direct <img src> URL for the logged-in user's avatar.
// The endpoint accepts the JWT via ?auth= (an <img> can't send headers).
// avatar_updated_at busts the cache after a new upload.
export const avatarUrl = (user, token) => {
  if (!user?.avatar_path || !token) return null;
  const api = `${process.env.REACT_APP_BACKEND_URL}/api`;
  const v = user.avatar_updated_at ? `&v=${encodeURIComponent(user.avatar_updated_at)}` : '';
  return `${api}/auth/avatar?auth=${encodeURIComponent(token)}${v}`;
};
